export type Point = { x: number; y: number };

export type Annotation = {
  id: number;
  uid: number;
  x: number;
  confidence?: number;
  y: number;
  width: number;
  type:
    | 'font_manipulation'
    | 'image_manipulation'
    | 'positional_anomaly'
    | 'semantic_anomaly'
    | 'layer_versions'
    | 'general_edits';
  height: number;
  description?: string;
  severity?: 'HIGH' | 'MEDIUM' | 'LOW';
  comment?: string;
  source: 'inference' | 'audit';
};

export type Annotations = Annotation[];
export enum AnnotationsActionEnum {
  removeDraftAnnotation = 'REMOVE_DRAFT_ANNOTATION',
  addAnnotation = 'ADD_ANNOTATION',
  updateAnnotationType = 'UPDATE_ANNOTATION_TYPE',
  addComment = 'ADD_COMMENT',
  setAnnotations = 'SET_ANNOTATIONS',
  resizeAnnotation = 'RESIZE_ANNOTATION',
  moveAnnotation = 'MOVE_ANNOTATION',
  deleteAnnotation = 'DELETE_ANNOTATION'
}
export type AddCommentAction = {
  type: AnnotationsActionEnum.addComment;
  payload: {
    id: number;
    comment: string;
  };
};

export type AddAnnotationAction = {
  type: AnnotationsActionEnum.addAnnotation;
  payload: Annotation;
};

export type UpdateAnnotationTypeAction = {
  type: AnnotationsActionEnum.updateAnnotationType;
  payload: {
    id: number;
    annotationType: 'font_manipulation' | 'image_manipulation';
  };
};

export type SetAnnotations = {
  type: AnnotationsActionEnum.setAnnotations;
  payload: Annotation[];
};

export type ResizeAnnotation = {
  type: AnnotationsActionEnum.resizeAnnotation;
  payload: {
    activeId: number;
    resizeHandle: string;
    x: number;
    y: number;
  };
};

export type MoveAnnotation = {
  type: AnnotationsActionEnum.moveAnnotation;
  payload: {
    activeId: number;
    dx: number;
    dy: number;
    naturalWidth: number;
    naturalHeight: number;
  };
};

export type RemoveDraftAnnotation = {
  type: AnnotationsActionEnum.removeDraftAnnotation;
};

export type DeleteAnnotation = {
  type: AnnotationsActionEnum.deleteAnnotation;
  payload: {
    activeId: number;
  };
};

export type AnnotationsAction =
  | AddAnnotationAction
  | SetAnnotations
  | UpdateAnnotationTypeAction
  | AddCommentAction
  | ResizeAnnotation
  | MoveAnnotation
  | RemoveDraftAnnotation
  | DeleteAnnotation;
